import { ContentView } from "../../components/content-view/ContentView";
import ContextualAppBar from "../../components/contextual-app-bar/ContextualAppBar";
import useManualEntryFormState from "./ManualEntryFormViewState";
import ManualEntryFormContent from "./ManualEntryFormContent";
import { forwardRef, Ref, useEffect, useImperativeHandle } from "react";
import { useConfirmation } from "../../contexts/confirmation-context/ConfirmationContext";
import { useTranslation } from "react-i18next";


export type ManualEntryFormViewProps = {

    hideAppBar?: boolean;
    hideOptions?: boolean;
    date?: Date;
}

export type  ManualEntryFormViewType = {
    allowChangeDate?: () => Promise<boolean>;
};


function ManualEntryFormView({
    hideAppBar,
    hideOptions,
    date,
}: ManualEntryFormViewProps, ref: Ref<unknown> | undefined) {

    const { confirm } = useConfirmation();
    const manualEntryFormState = useManualEntryFormState();
    const{t} = useTranslation()

    const { 
        state,
        setSelectedDate,
        setEndDate,
    

    } = manualEntryFormState;


    useImperativeHandle<unknown, ManualEntryFormViewType>(
        ref,
        () => ({
            allowChangeDate: canChangeDate
        })
    );


    const canChangeDate = async () => {

        if (state.formState.isDirty) {
            return await getUserConfirmation();
        }

        return true;
    }

    const getUserConfirmation = async () => {

        const response = await confirm({
            dialogTitle: t('cancelConfirmation.title'),
            confirmationText: t('tag.cancelEditText'),
            yesButtonText: t('cancelConfirmation.yesButtonText'),
            noButtonText: t('cancelConfirmation.noButtonText'),
            showConfirmationText: true,
            showYesButton: true,
            showNoButton: true
        });
        
        if (response === "yes") {
            return true
        }

        setSelectedDate(state.selectedDate);
        
        return false;
    };


    useEffect(() => {
        if (date) {
            setSelectedDate(date);
            setEndDate(date);
        }
        
    }, [
        date,
        setSelectedDate,
        setEndDate
    ]);

    useEffect(() => {
        
    })

    return (

        <ContentView>
            {!hideAppBar && <ContextualAppBar 
                viewOptionState={state.viewOptionState}
            />}

            <ManualEntryFormContent manualEntryFormState={manualEntryFormState} hideOptions={hideOptions} />
           
        </ContentView>

    );
}

export default forwardRef(ManualEntryFormView);